export enum EnumHistoryType {
    'Exam' = 'EXAM',
    'Study' = 'STUDY'
}